import {
  HorarioSpa,
  NuevoAgendamientoSpa,
} from "../../../services/agendamientosSpaServicios";
import { NuevoItemCarritoSpaRequest } from "../../../services/carritoServicios";
import { ItemListadoServiciosSpa } from "../../../services/spaServicios";
import { MetodoPago } from "../../../services/ventasServicios";
import { obtenerStringDeFecha } from "../../../utils/dateUtils";

export interface Model {
  idMascota: string;
  idPropietario: string;
  nombreMascota: string;
  nombresPropietario: string;
  fechasReservadasAnteriormente: Date[];
  tarifa?: ItemListadoServiciosSpa;
  valorFinalTarifa?: number;
  fechasProgramadas: Date[];
  total?: number;
  descuento: number;
  pago?: PagoModel;
  horario: HorarioSpa;
}

export interface PagoModel {
  monto: number;
  metodo: MetodoPago;
}

export const defaultModel: Model = {
  idMascota: "",
  idPropietario: "",
  nombreMascota: "",
  nombresPropietario: "",
  fechasProgramadas: [],
  fechasReservadasAnteriormente: [],
  horario: "MANANA",
  descuento: 0,
};

export const buildNuevoAgendamientoSpa = (
  model: Model
): NuevoAgendamientoSpa => {
  return {
    idMascota: model.idMascota,
    datosReservaSpa: {
      fechasProgramadas: model.fechasProgramadas,
      datosTarifa: {
        idTarifa: model.tarifa!.id,
        precioFinal: model.valorFinalTarifa!,
      },
      horario: model.horario,
    },
    descuento: model.descuento,
    datosPago: model.pago
      ? {
          metodo: model.pago!.metodo,
          monto: model.pago!.monto,
        }
      : undefined,
  };
};

export const buildNuevoItemCarritoSpa = (
  model: Model
): NuevoItemCarritoSpaRequest => {
  return {
    idPropietario: model.idPropietario,
    tipoServicio: "SPA",
    idMascota: model.idMascota,
    fechasProgramadas: model.fechasProgramadas.map((f) =>
      obtenerStringDeFecha(f)
    ),
    datosTarifa: {
      idTarifa: model.tarifa!.id,
      precioFinal: model.valorFinalTarifa!,
    },
    horario: model.horario,
  };
};
